export const appNames = {
    spend: "Spend",
    coman: "CO MAN",
    contract: "Contract",
    sustainability: "Sustainability",
    marketIntel: "Market Intelligence",
    smartCube: "smartCube",
    supplierPerformance: "Supplier Performance",
    compass: "Compass",
    archlet: "Archlet",
    powersteering: "Power Steering",
    forestreet: "Fore Street",
    resilinc: "Resilinc",
    shouldCostModelling: "SCM",
    veridion: "Veridion",
    r2pInsights: "R2P Insights"
}
